"use client";

import { c as _c } from "react/compiler-runtime";
import { IconLayoutSidebarLeftCollapse, IconLayoutSidebarLeftExpand, IconSun, IconMoon } from "@tabler/icons-react";
type WorkspaceTopbarProps = {
  title?: string;
  subtitle?: string;
  sidebarOpen?: boolean;
  onToggleSidebar?: () => void;
  isDark?: boolean;
  onToggleTheme?: () => void;
  userName?: string;
  userEmail?: string;
  onLogout?: () => void;
};
{/* ============================================================
    MA2TIC ORG — Proprietary Software
    © 2026 MA2TIC. All Rights Reserved.
     Licensed to: MA2TIC Organisation
    Owners: Archana Thakur | Tanisha Bhardwaj |
            Manika Kutiyal | Aditya Verma
     NOTICE: This software is proprietary and confidential.
    Unauthorized copying, fragmentation, redistribution,
    or publication of this code, in whole or in part,
    is strictly prohibited without prior written permission
    from the MA2TIC development team.
     For permissions and licensing inquiries, contact MA2TIC.
    ============================================================ */}
export function WorkspaceTopbar(t0) {
  const $ = _c(27);
  const {
    title: t1,
    subtitle,
    sidebarOpen: t2,
    onToggleSidebar,
    isDark: t3,
    onToggleTheme,
    userName,
    userEmail,
    onLogout
  } = t0;
  const title = t1 === undefined ? "Cognitive Analysis" : t1;
  const sidebarOpen = t2 === undefined ? true : t2;
  const isDark = t3 === undefined ? false : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      background: "var(--nt-hdr)",
      borderBottom: "1px solid var(--nt-hdr-border)",
      backdropFilter: "blur(14px)",
      WebkitBackdropFilter: "blur(14px)",
      transition: "background 0.3s, border-color 0.3s"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== onToggleSidebar || $[2] !== sidebarOpen) {
    t5 = onToggleSidebar && <button onClick={onToggleSidebar} className="nt-nav-btn flex items-center justify-center w-7 h-7 rounded-md shrink-0" title={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}>{sidebarOpen ? <IconLayoutSidebarLeftCollapse size={16} stroke={1.6} /> : <IconLayoutSidebarLeftExpand size={16} stroke={1.6} />}</button>;
    $[1] = onToggleSidebar;
    $[2] = sidebarOpen;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      border: "1.5px solid var(--nt-text-xs)"
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="w-3.5 h-3.5 rounded-sm flex items-center justify-center shrink-0" style={t6}><div className="w-1.5 h-1.5 rounded-[1px]" style={{
        background: "var(--nt-text-xs)"
      }} /></div>;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      color: "var(--nt-text-md)",
      fontFamily: "var(--font-dm-sans), sans-serif"
    };
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== title) {
    t9 = <span className="text-[12px] sm:text-[13px] font-medium tracking-tight truncate max-w-[44vw] sm:max-w-none" style={t8}>{title}</span>;
    $[7] = title;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== subtitle) {
    t10 = subtitle && <><span style={{
        color: "var(--nt-text-ghost)"
      }} className="text-sm">/</span><span className="text-[13px]" style={{
        color: "var(--nt-text-xs)"
      }}>{subtitle}</span></>;
    $[9] = subtitle;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex-1" />;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== userEmail || $[13] !== userName) {
    t12 = userName && <div className="hidden md:flex flex-col items-end leading-tight mr-2"><span className="text-[11px] font-medium" style={{
        color: "var(--nt-text-lo)"
      }}>Logged in as {userName}</span>{userEmail && <span className="text-[10px]" style={{
        color: "var(--nt-text-ghost)"
      }}>{userEmail}</span>}</div>;
    $[12] = userEmail;
    $[13] = userName;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== onLogout) {
    t13 = onLogout && <button onClick={onLogout} className="nt-nav-btn flex items-center justify-center px-2.5 h-7 rounded-md shrink-0 text-[11px]" title="Log out">Logout</button>;
    $[15] = onLogout;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== isDark || $[18] !== onToggleTheme) {
    t14 = onToggleTheme && <button onClick={onToggleTheme} className="nt-nav-btn flex items-center justify-center w-7 h-7 rounded-md shrink-0" title={isDark ? "Switch to light mode" : "Switch to dark mode"}>{isDark ? <IconSun size={15} stroke={1.6} /> : <IconMoon size={15} stroke={1.6} />}</button>;
    $[17] = isDark;
    $[18] = onToggleTheme;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t10 || $[21] !== t12 || $[22] !== t13 || $[23] !== t14 || $[24] !== t5 || $[25] !== t9) {
    t15 = <header className="flex items-center gap-2 sm:gap-3 px-3 sm:px-4 h-11 shrink-0 min-w-0" style={t4}>{t5}{t7}{t9}{t10}{t11}{t12}{t13}{t14}</header>;
    $[20] = t10;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
    $[24] = t5;
    $[25] = t9;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  return t15;
}